<template>
  <div class="customer-list clearfix">
    <Search @getHeight="getHeight"
            @add="addCate"
            @saveSet="saveSet"
            :tableConfig="tableConfig"
            :tableName="tableName"
            :isquery="true"
            :advancedQuery="false"
            :sortPara="sortPara"
            :delPara="delPara"
            :showAdd="false"
            :showDel="false"
            :showSort="false"
            searchName="getInterestedInList">
      <template v-slot:left>
        <!-- <el-col :lg="12"
                :md="12"
                :sm="12"
                :xs="12">
          <el-form-item label="企业简称">
            <el-select v-model="searchForm.enterpriseId"
                       clearable
                       placeholder="请选择">
              <el-option v-for="item in companyList"
                         :key="item.id"
                         :label="item.shortName || item.fullName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :lg="24"
                :md="24"
                :sm="24"
                :xs="24">
          <el-form-item label="关键字"
                        prop="keyWord">
            <el-input @keyup.enter.native="$refs.Search.handleSearch"
                      v-model="searchForm.keyWord"
                      clearable
                      placeholder="请输入关键字查询"></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="7"
                :md="10"
                :sm="12"
                :xs="24">
          <el-form-item label="报名时间">
            <el-col :span="11">
              <el-date-picker v-model="searchForm.createDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              style="width: 100%"
                              placeholder="选择开始日期">
              </el-date-picker>
            </el-col>
            <el-col :span="1">~</el-col>

            <el-col :span="11">
              <el-date-picker v-model="searchForm.endDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              style="width: 100%"
                              placeholder="选择结束日期">
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </Search>
    <div class="customer-table-list fr page">
      <MyTable @inputChange="inputChange"
               :tableData="tableData"
               @selectionChange="handleSelectionChange"
               :tableConfig="tableConfig"
               :height="tableHeight"
               tableEmptyText="暂无数据，点击新增"
               @EmptyBtn="addCate"
               :indexFlag="true">
        <template v-slot:index="slotData">
          {{
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:time="slotData">
          {{
              slotData.scope.row.applyDate &&
              slotData.scope.row.applyDate.slice(0, 10)
            }}
        </template>
        <template v-slot:applyStatus="slotData">
          {{
              slotData.scope.row.applyStatus === '待处理' ?   '已报名': slotData.scope.row.applyStatus 
            }}
        </template>
        <template v-slot:sort="slotData">
          <el-input-number size="small"
                           :precision="0"
                           v-model="slotData.scope.row.sort"
                           controls-position="right"
                           @change="slotData.scope.row.add = '1'"></el-input-number>
        </template>
        <template v-slot:attachmentPath="slotData">

          <i class="el-icon-document"
             style="font-size: 35px;cursor: pointer;"
             @click="previewFile(slotData.scope.row.attachmentPath)"
             v-if="slotData.scope.row.attachmentPath"></i>

        </template>

        <template v-slot:operation="slotData">
          <el-button @click="Cancel(slotData.scope.row.id)"
                     size="small"
                     icon="el-icon-edit"
                     v-if="verifyPermission('Update') && slotData.scope.row.applyStatus === '待处理'">取消报名</el-button>
          <!-- <el-button
            @click="deleteCategory(slotData.scope.row.id)"
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            v-if="verifyPermission('Delete')"
            >删除</el-button
          > -->
        </template>
      </MyTable>
      <!-- <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="getInterestedInList"
                  ref="pagination" /> -->
    </div>

    <!-- 添加职位类型弹窗 -->
    <el-dialog :title="flag ? '新增职位类型' : '编辑职位类型'"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="500px"
               @close="resetForm">
      <el-form ref="form"
               :model="form"
               :rules="rules"
               label-width="80px">
        <el-form-item label="类别名称"
                      prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="排序"
                      class="number-footer">
          <el-input-number v-model="form.sort"
                           :precision="0"></el-input-number>
        </el-form-item>

        <!-- <el-form-item label="是否管理员">
          <el-switch v-model="form.isManage"></el-switch>
        </el-form-item> -->
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              resetForm();
              dialogVisible = false;
            }
          ">取 消</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="addCategory('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from "@/components/Table";

import { verifyPermissionMinix } from "@/utils/mixin";
import Search from "@/components/Search";

export default {
  components: {
    MyTable,
    Search,
  },
  mixins: [verifyPermissionMinix],

  data () {
    return {
      sortPara: {
        data: "",
        controller: "posts",
        action: "EditPositionTypeSort",
        callback: "getInterestedInList",
      },
      tableName: "categoryListTable",
      Id: "",
      submitLoading: false,
      flag: true,
      form: {},
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入类别名称", trigger: "blur" }],
      },
      tableConfig: [
        {
          field: "fullName",
          label: "企业名称",
          flag: true,
          align: "center",
        },
        {
          field: "address",
          label: "企业地址",
          flag: true,
          align: "center",
        },
        {
          field: "jobStatus",
          label: "状态",
          align: "center",

          flag: true,
        },

      ],
      tabList: [],
      tabIndex: 0,
      currentRow: null,
      drawerTitle: "",
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {},
      operation: "",
      companyId: "",
      tableHeight: "",
      companyList: [],
      delPara: {
        data: "",
        controller: "posts",
        action: "PositionTypeBtachDelete",
        callback: "getInterestedInList",
      },
    };
  },
  computed: {},
  mounted () {
    this.getCompanyList();
    this.getInterestedInList();
  },
  methods: {
    addCate () {
      this.flag = true;
      this.dialogVisible = true;
    },
    //批量选择
    handleSelectionChange (selection) {
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },

    // 列的显示与隐藏
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    // 获取企业列表
    getCompanyList () {
      let sendData = {
        pageSize: -1,
      }
      this.$api.EnterpriseInfo.List(sendData).then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        }
      });
    },
    previewFile (value) {
      window.open(value, "_blank");

    },
    inputChange (value, field, id) { },
    //获取高度
    getHeight (height) {
      this.tableHeight = height;
    },
    //表单重置
    resetForm () {
      this.form = {};
      this.$refs.form.clearValidate();
    },
    Cancel (id) {
      this.$confirm("是否确认取消报名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.IndividualUser.CancelJobApply([id]).then((res) => {
            if (res.error == false) {
              this.getInterestedInList();
              this.$message.success("取消成功");
            }
          });
        })
        .catch(() => { });
    },
    //获取数据
    getInterestedInList () {
      this.loading = true;
      const sendData = {
        pageIndex: 1,
        pageSize: -1,
        wheres: [
          {
            name: "keyword",
            value: this.searchForm.keyWord,
            expressionType: "Like",
          },
        ],
      };

      this.$api.IndividualUser.InterestedInList(sendData).then((res) => {
        if (res.error === false) {
          this.loading = false;
          this.tableData = [];
          if (res.data.joinList.length > 0) {
            this.tableData = this.tableData.concat(res.data.joinList);
          }
          if (res.data.interestedInList.length > 0) {
            this.tableData = this.tableData.concat(res.data.interestedInList);
          }
          console.log(this.tableData);
          // this.total = res.data.count;
        }
      });
    },

    // 添加类别
    addCategory () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          let sendData = {
            name: this.form.name,
            sort: this.form.sort,
          };
          if (this.flag == false) {
            sendData.id = this.Id;
          }
          console.log(sendData);
          this.$api.posts
            .PositionTypeEdit(JSON.stringify(sendData))
            .then((res) => {
              if (res.error == false) {
                this.getInterestedInList();
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.submitLoading = false;
              }
            });
        } else {
          //就像用户提示发生错误的消息
        }
      });
    },
    // 删除类别
    deleteCategory (ids) {
      const formData = new FormData();
      formData.append("id", ids);
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.posts.PositionTypeDelete(formData).then((res) => {

            if (res.error === false) {
              this.getInterestedInList();
              this.$message.success("删除成功");
            }
          });
        })
        .catch(() => { });
    },
    // 获取类别详情
    getCategoryDetails (id) {
      return new Promise((resolve, reject) => {
        this.$api.posts.PositionTypeDetail(id).then((res) => {

          if (res.error === false) {
            resolve(res.data);
          } else {
            reject("error");
          }
        });
      });
    },
    // 修改类别信息
    editCategoryInfo (row) {
      this.Id = row.id;
      this.getCategoryDetails(row.id).then((res) => {
        if (res) {
          this.dialogVisible = true;
          this.flag = false;
          this.$set(this.form, "name", res.name);
          this.$set(this.form, "sort", res.sort == null ? undefined : res.sort);
        }
      });
    },
    // 查询
    handleSearch () {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      this.getInterestedInList();
    },
  },
};
</script>

<style lang="less">
.btn {
  margin-left: 15px;
}
</style>
